import {useCallback, useEffect, useState} from 'react';
import {scheduledJobApi, ScheduledJobSummary} from '../../services/api';
import {connectedJobsFor as connectedJobsForRule, estimateScanCost} from './tableRules';

// Connected jobs (Connected Jobs column). Admin-only: GET /api/scheduled-jobs
// is admin-gated, so we only fetch for admins and filter client-side by
// job.promptIds. No backend changes — pure client derivation.
export function useConnectedJobs(isAdmin: boolean) {
    const [scheduledJobs, setScheduledJobs] = useState<ScheduledJobSummary[]>([]);

    useEffect(() => {
        if (!isAdmin) {
            setScheduledJobs([]);
            return;
        }
        let cancelled = false;
        scheduledJobApi
            .getAll()
            .then(jobs => {
                if (!cancelled) setScheduledJobs(Array.isArray(jobs) ? jobs : []);
            })
            .catch(() => {
                if (!cancelled) setScheduledJobs([]);
            });
        return () => {
            cancelled = true;
        };
    }, [isAdmin]);

    const connectedJobsFor = useCallback(
        (promptId: string) => connectedJobsForRule(scheduledJobs, promptId),
        [scheduledJobs],
    );

    const estScanCostFor = useCallback(
        (promptId: string): number | null => estimateScanCost(connectedJobsFor(promptId)),
        [connectedJobsFor],
    );

    return {connectedJobsFor, estScanCostFor};
}
